<template>
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Case</h5>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group">
              <input
                type="file"
                class="form-control mb-3"
                @change="fileChange"
              />
              <div class="row">
                <div class="col">
                  <!-- Title EN -->
                  <label for="titleEn" class="form-label">Title EN</label>
                  <input
                    type="text"
                    class="form-control"
                    id="titleEn"
                    v-model="titleEn"
                    @change="update('titleEn', titleEn)"
                  />

                  <!-- Description EN -->
                  <label for="descriptionEn" class="form-label"
                    >Description EN</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="descriptionEn"
                    v-model="descriptionEn"
                    @change="update('descriptionEn', descriptionEn)"
                  />
                </div>
                <div class="col">
                  <!-- Title CH -->
                  <label for="titleEn" class="form-label">Title CH</label>
                  <input
                    type="text"
                    class="form-control"
                    id="titleCh"
                    v-model="titleCh"
                    @change="update('titleCh', titleCh)"
                  />
                  <!-- Description CH -->
                  <label for="descriptionCh" class="form-label"
                    >Description CH</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="descriptionCh"
                    v-model="descriptionCh"
                    @change="update('descriptionCh', descriptionCh)"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="saveChanges">
            Save
          </button>
          <button type="button" class="btn btn-secondary" @click="closeModal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authHeader from "../../services/authHeader";
import axios from "axios";
export default {
  name: "ModalEventEdit",
  props: ["c"],
  data() {
    return {
      image: null,
      imageData: "",
      link: this.c.link,
      titleEn: this.c.titleEn,
      titleCh: this.c.titleCh,
      descriptionEn: this.c.descriptionEn,
      descriptionCh: this.c.descriptionCh,
      obj: {},
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal-case");
    },
    saveChanges() {
      if (this.imageData) {
        this.obj["mainImageType"] = "estate/listing";
        this.obj["mainImageField"] = "mainImage";
        this.obj["imageData"] = this.imageData;
      }
      this.obj["itemId"] = this.c._id;
      axios
        .put(this.$webDomain +"/garden/GardenCase", this.obj, {
          headers: authHeader(),
        })
        .then(function(response) {
          console.log(response);
          window.location.reload();
        })
        .catch(function(error) {
          console.log(error);
        });

      this.closeModal();
    },
    fileChange(e) {
      this.image = e.target.files[0];
      const reader = new FileReader();
      reader.onloadend = (e) => {
        this.imageData = e.target.result;
      };
      reader.readAsDataURL(this.image);
    },
    update(key, value) {
      if (
        key === "link" ||
        key === "titleCh" ||
        key === "titleEn" ||
        key === "descriptionEn" ||
        key === "descriptionCh"
      ) {
        this.obj[key] = value;
      }
    },
  },
};
</script>

<style scoped>
/* Override default value of 'none' */
.modal {
  display: block;
}

.form-label {
  margin-top: 0.5rem;
}
</style>
